import React from 'react'
import styles from './img.module.css'

export default ({ src, caption, narrow }) => (
  <div className={styles.image}>
    {narrow ? <img className={styles.narrow} src={src} /> : <img src={src} />}
    {caption && <p className='small'>{caption}</p>}    
  </div>
)
